export const NUMBER_PLACEHOLDER = "+7 (___) ___-__-__";